import { render, staticRenderFns } from "./qa-answer-audit.vue?vue&type=template&id=05de5ee6&scoped=true&"
import script from "./qa-answer-audit.vue?vue&type=script&lang=js&"
export * from "./qa-answer-audit.vue?vue&type=script&lang=js&"
import style0 from "./qa-answer-audit.vue?vue&type=style&index=0&id=05de5ee6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05de5ee6",
  null
  
)

export default component.exports